import { render, staticRenderFns } from "./reports.create.component.vue?vue&type=template&id=28ae0362&scoped=true&"
import script from "./reports.create.component.vue?vue&type=script&lang=js&"
export * from "./reports.create.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae0362",
  null
  
)

export default component.exports